import React, { Fragment, useState, useEffect } from 'react';
import moment from 'moment';
// store
import { authService } from "../../../../store/services/ServiceAuth";
import { paymentService } from "../../../../store/services/ServicePayment";
// components
import HeaderTitle from "../../../../components/others/HeaderTitle";
import Loading from "../../../../components/others/Loading";
import { Form, Button, Card, Icon } from "semantic-ui-react";
import { DateInput } from "semantic-ui-calendar-react";
import RewardsTable from './RewardsTable';

const Rewards = () => {
    authService.useIsProvider();

    const [isLoading, setIsLoading] = useState(true)
    const [filters, setFilters] = useState({
        from: moment().startOf('month').format("DD.MM.YYYY"),
        to: moment().endOf('month').format("DD.MM.YYYY"),
        type: "",
        is_paid: null,
    })
    const [rewards, setRewards] = useState([])
    const [isMobile, setIsMobile] = useState(false);
    const [showFilters, setShowFilters] = useState(false);

    async function fetchRewards() {
        setIsLoading(true);

        let params = "?query="
        if (filters.from) params += `&from=${moment(filters.from, "DD.MM.YYYY").format("YYYY-MM-DD")}`
        if (filters.to) params += `&to=${moment(filters.to, "DD.MM.YYYY").format("YYYY-MM-DD")}`
        if (filters.is_paid !== null) params += `&is_paid=${filters.is_paid}`

        const request = await paymentService.getProviderRewards(params)

        if (request.status === 200) {
            setRewards(request.response)
        }

        setIsLoading(false);
    }

    const handleFilter = async () => {
        await fetchRewards()
        if (isMobile) {
            setShowFilters(false)
        }
    }

    useEffect(() => {
        fetchRewards()
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        const media = window.matchMedia("(max-width: 768px)");
        const handleChange = () => setIsMobile(media.matches);
        handleChange();
        if (media.addEventListener) {
            media.addEventListener("change", handleChange);
        } else {
            media.addListener(handleChange);
        }
        return () => {
            if (media.removeEventListener) {
                media.removeEventListener("change", handleChange);
            } else {
                media.removeListener(handleChange);
            }
        };
    }, []);

    return (
        <Fragment>
            <HeaderTitle title="Prehľad odmien" />
            <section>
                {isMobile && (
                    <div style={{ marginBottom: "1rem" }}>
                        <div
                            onClick={() => setShowFilters(!showFilters)}
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                padding: "0.85rem 1rem",
                                background: "#f8f9fa",
                                border: "1px solid #e0e0e0",
                                borderRadius: "8px",
                                cursor: "pointer",
                                transition: "all 0.2s ease"
                            }}
                        >
                            <div style={{ display: "flex", gap: "0.65rem" }}>
                                <Icon name="sliders horizontal" style={{ margin: 0, fontSize: "1.05rem", color: "#555" }} />
                                <span style={{ fontSize: "0.95rem", fontWeight: 600, color: "#333" }}>Filtrovať</span>
                            </div>
                            <div style={{ display: "flex", gap: "0.6rem" }}>
                                <span style={{ fontSize: "0.85rem", color: "#666", fontWeight: 500 }}>{filters.from} - {filters.to}</span>
                                <Icon name={showFilters ? "chevron up" : "chevron down"} style={{ margin: 0, fontSize: "0.95rem", color: "#555" }} />
                            </div>
                        </div>
                    </div>
                )}

                {(showFilters || !isMobile) && (
                    <Card fluid style={{ borderRadius: "8px", border: "1px solid #e0e0e0", marginBottom: "1rem", boxShadow: "none", overflow: isMobile ? "visible" : "initial" }}>
                        <Card.Content style={{ padding: isMobile ? "1rem" : "1.25rem", overflow: isMobile ? "visible" : "initial" }}>
                            <Form onSubmit={handleFilter} style={{ overflow: isMobile ? "visible" : "initial" }}>
                                <div style={{ marginBottom: "1rem" }}>
                                    <Form.Group style={{ marginBottom: 0 }}>
                                        <Form.Checkbox
                                            label="Všetky"
                                            checked={filters.is_paid === null}
                                            onChange={(e, { checked }) => setFilters({ ...filters, is_paid: null })}
                                        />
                                        <Form.Checkbox
                                            label="Vyplatené"
                                            checked={filters.is_paid === true}
                                            onChange={(e, { checked }) => setFilters({ ...filters, is_paid: true })}
                                        />
                                        <Form.Checkbox
                                            label="Nevyplatené"
                                            checked={filters.is_paid === false}
                                            onChange={(e, { checked }) => setFilters({ ...filters, is_paid: false })}
                                        />
                                    </Form.Group>
                                </div>
                                <div style={{ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr auto", gap: isMobile ? "1rem" : "1rem", alignItems: "end", width: "100%", maxWidth: "100%" }}>
                                    <Form.Field style={{ margin: 0 }}>
                                        <label style={{ fontSize: "0.85rem", fontWeight: 600, color: "#555", marginBottom: "0.4rem", display: "block" }}>
                                            Dátum od
                                        </label>
                                        <DateInput
                                            fluid
                                            localization="sk"
                                            placeholder="DD.MM.YYYY"
                                            dateFormat="DD.MM.YYYY"
                                            value={filters.from}
                                            onChange={(e, { value }) => setFilters({ ...filters, from: value })}
                                            iconPosition="right"
                                            animation="none"
                                            closable
                                            hideMobileKeyboard
                                        />
                                    </Form.Field>
                                    <Form.Field style={{ margin: 0 }}>
                                        <label style={{ fontSize: "0.85rem", fontWeight: 600, color: "#555", marginBottom: "0.4rem", display: "block" }}>
                                            Dátum do
                                        </label>
                                        <DateInput
                                            fluid
                                            localization="sk"
                                            placeholder="DD.MM.YYYY"
                                            dateFormat="DD.MM.YYYY"
                                            value={filters.to}
                                            onChange={(e, { value }) => setFilters({ ...filters, to: value })}
                                            iconPosition="right"
                                            animation="none"
                                            closable
                                            hideMobileKeyboard
                                        />
                                    </Form.Field>
                                    <Button
                                        fluid
                                        type="submit"
                                        disabled={isLoading || (filters.from === "" || filters.to === "")}
                                        style={{
                                            background: "var(--primary)",
                                            color: "#fff",
                                            borderRadius: "6px",
                                            fontWeight: 600,
                                            padding: "0.85rem 1.5rem",
                                            border: "none",
                                            minWidth: isMobile ? "100%" : "120px"
                                        }}
                                    >
                                        Potvrdiť
                                    </Button>
                                </div>
                            </Form>
                        </Card.Content>
                    </Card>
                )}

                {isLoading
                    ? <Loading />
                    : <RewardsTable rewards={rewards} />
                }
            </section>
        </Fragment>
    );
};

export default Rewards;